export default {
  nextSlide: {
    id: 'product_jp_product_condition_screen_carousel_next',
    defaultMessage: 'Next slide',
  },
  previousSlide: {
    id: 'product_jp_product_condition_screen_carousel_next',
    defaultMessage: 'Next slide',
  },
}
